/**
 * The English catalogue — the source of truth for every message key and its parameters
 * (docs/Localization.md). Sections live in ./en/; each has a German twin in ./de/.
 */
import { aar } from './en/aar';
import { academy } from './en/academy';
import { common } from './en/common';
import { dispatch } from './en/dispatch';
import { hud } from './en/hud';
import { manual } from './en/manual';
import { map } from './en/map';
import { menu } from './en/menu';
import { mp } from './en/mp';
import { news } from './en/news';
import { setup } from './en/setup';

export const en = {
  ...common,
  ...menu,
  ...setup,
  ...mp,
  ...hud,
  ...dispatch,
  ...news,
  ...aar,
  ...manual,
  ...academy,
  ...map,
} as const;

export type En = typeof en;
